import React from "react";

interface RegistrationSectionProps {
	children?: any;
	title?: string;
	className?: string;
}

const RegistrationSection = ({
	title,
	children,
	className: _className,
}: RegistrationSectionProps) => {
	let className = `p-6 rounded-md flex flex-col ${_className || ""}`;

	if (!className?.includes("bg-")) {
		className += " bg-gray";
	}

	return (
		<div {...{ className }}>
			{title && (
				<strong className="text-[22px] block mb-5">{title}</strong>
			)}
			<div className="flex flex-col flex-1 gap-4">{children}</div>
		</div>
	);
};

export default RegistrationSection;
